<template>
  <page>
    <lazy-div :load="doInit">
      <v-toolbar dense color="grey lighten-3" flat>
        <v-btn text icon color="green">
          <v-icon @click="doBack">mdi-keyboard-backspace</v-icon>
        </v-btn>
        <v-toolbar-title class="toolbar-title-custom">Cover Type: {{ getDesc(cvrType) }}</v-toolbar-title>
      </v-toolbar>
      <v-card>
        <v-tabs v-model="tabValue" slider-color="primary">
          <v-tab @click="resetTab">Listing</v-tab>
          <v-tab v-show="review">Detail</v-tab>
          <v-tab-item>
            <v-toolbar dense color="grey lighten-3" flat>
              <v-toolbar-title>Permitted Cover Type per Business Class</v-toolbar-title>
            </v-toolbar>
            <v-card-title>
              <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
              <v-spacer></v-spacer>
              <v-btn color="primary" dark class=" mr-2" @click="doNew">
                New Permitted Cover Type
                <v-icon right>mdi-plus</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-title>
              <v-flex xs12>
                <v-subheader class="queryLabel">{{ labels.cvrType }}</v-subheader>
                <div class="queryValue">{{ getDesc(cvrType) }}</div>
              </v-flex>
            </v-card-title>
            <v-card>
              <v-data-table
                :headers="headers"
                :items="items"
                :search="search"
                :footer-props="{'items-per-page-options': itemsPerPage }"
                v-bind:options.sync="pagination"
                item-key="name"
                :loading="loading"
                :no-data-text="noDataText"
                :custom-filter="customSearch"
              >
                <template v-slot:item="row"
                  ><tr>
                    <td class="text-xs-left">{{ row.item.busCls }}</td>
                    <td class="text-xs-left">{{ row.item.busClsDesc }}</td>
                    <td class="table-action-header">
                      <table-action :rowData="row" query @query="doQuery(row.item)" remove @remove="doPromptRemove(row.item)"></table-action>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card>
            <confirm v-model="promptRemove" @ok="doRemove">
              Are you sure you want to delete the selected record? ({{ selectedBusClsCvr.busCls + ', ' + selectedBusClsCvr.cvrType }})
            </confirm>
          </v-tab-item>
          <v-tab-item v-show="review">
            <buscls-cvr-review :cvrType="cvrType" :menu="menu" :tranMode="tranMode" :busCls="busCls" @close="resetTab"></buscls-cvr-review>
          </v-tab-item>
        </v-tabs>
      </v-card>
    </lazy-div>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { extractMenu } from '@/utils/extract'
import { expandURI } from '@/utils/ajax'
import BusclsCvrReview from './BusClsCvrReview'

export default {
  props: ['cvrType'],
  data() {
    return {
      toogleArray: [false],
      headers: [
        { text: 'Business Class', align: 'left', value: 'busCls' },
        { text: 'Description', value: 'busClsDesc' },
        TableConst.tableActionHeader
      ],
      labels: {
        cvrType: 'Cover Type',
        polType: 'Policy Type'
      },
      filters: {
        polType: null
      },
      selectedBusClsCvr: {},
      busClsList: [],
      cvrTypeList: [],
      tabValue: 0,
      review: false,
      polTypeList: [],
      loading: false,
      promptRemove: false,
      busCls: null,
      totalItems: 0,
      menu: {},
      tranMode: null,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  async created() {
    this.doInit()
  },
  methods: {
    async doInit() {
      try {
        await this.$store.dispatch('busClsManagementInit')
        const apiURI = this.$store.state.busClsParam.menu.getBusClsCvrMenu
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.menu = extractMenu(result.data._links)
          }
          this.getBusClsList()
          this.getCoverList()
          this.fetchData(true)
        }
      } catch (err) {
        throw err
      }
    },
    async fetchData() {
      const apiURI = this.menu.getBusClsCvrListByCvrType
      if (apiURI) {
        this.loading = true
        let expand = { cvrType: this.cvrType }
        const result = await this.$http.get(expandURI(apiURI, expand))
        if (result.data) {
          const { data } = result.data
          this.items = []
          if (data) {
            data.map((busClsCvr) => {
              const convertList = {
                busCls: busClsCvr.busCls,
                busClsDesc: busClsCvr.busClsDesc
              }
              this.items.push(convertList)
            })
          }
        }
        this.loading = false
      } else {
        this.items = []
      }
    },
    getDesc(id) {
      for (var i in this.cvrTypeList) {
        if (this.cvrTypeList[i].value === id) {
          return this.cvrTypeList[i].label
        }
      }
    },
    async getBusClsList() {
      const apiURI = this.menu.getBusClsList
      if (apiURI) {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        this.busClsList = []
        if (data) {
          data.map((busCls) => {
            const convertList = {
              label: busCls.busCls + ' - ' + busCls.busClsDesc,
              value: busCls.busCls
            }
            this.busClsList.push(convertList)
          })
        }
      }
    },
    async getCoverList() {
      const apiURI = this.menu.getCoverList
      if (apiURI) {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        this.cvrTypeList = []
        if (data) {
          data.map((cover) => {
            const convertList = {
              label: cover.label,
              value: cover.value
            }
            this.cvrTypeList.push(convertList)
          })
        }
      }
    },
    doNew() {
      this.busCls = 'new'
      this.review = true
      this.tabValue = 1
      this.tranMode = 'new'
    },
    doReview(data) {
      this.busCls = data.busCls
      this.review = true
      this.tabValue = 1
    },
    doPromptRemove(data) {
      this.resetMessages()
      this.selectedBusClsCvr = {
        busCls: data.busCls,
        cvrType: this.cvrType
      }
      this.promptRemove = true
    },
    async doRemove() {
      const apiURI = this.menu.deleteBusClsCvr
      if (apiURI) {
        const expand = this.selectedBusClsCvr
        this.$http
          .post(apiURI, expand)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.doInit(false)
          })
          .catch((err) => {
            const { data } = err.response
            this.message(data)
          })
      }
    },
    resetTab() {
      this.tabValue = 0
      this.doInit()
      this.review = false
      this.polTypeScheme = false
    },
    doQuery(data) {
      this.busCls = data.busCls
      this.review = true
      this.tabValue = 1
      this.tranMode = 'query'
    },
    doBack() {
      this.$router.push({ name: 'cover' })
    }
  },
  mixins: [TableConst.default, MessageMixin],
  components: {
    BusclsCvrReview
  }
}
</script>
